export default __webpack_public_path__ + "69e676fb49f789240a8b70236ea4add9.jpeg";